import { FC} from 'react';

import { MovieInfo } from '../components';

const MovieInfoPage: FC = () => {

    return (
        <div>
           <MovieInfo/>
        </div>
    );
};

export { MovieInfoPage };